import { AuthProvider } from './features/auth/Context/AuthProvider';
import { Switch, Route } from "wouter";
import { ProtectedAuthRoute } from './lib/protected-auth-route';
import { Toaster } from './components/Toaster';
import { withPageWrapper } from './lib/pageWrapper';
import './App.css'
import { PublicRoute } from "./lib/PublicRoute";
import { PrivateAuthLayoutRoute } from "./lib/PrivateAuthLayoutRoute";
import { PrivateMenuLayoutRoute } from './lib/PrivateMenuLayoutRoute';
import { lazy } from 'react';

// Pages
import SignIn from './modules/auth/sign-in';
import HomePage from './modules/home/page';
import NotFound from './modules/common/not-found';
import MaintenancePage from './modules/common/maintenance';

// Finanzas
const CollectionsManagementPage = lazy(
  () => import("./modules/finance/accounts-receivable/page")
);


// Gestión de Almacén
const ItemMasterPage = lazy(
  () => import("./modules/supply-chain/warehouse/items-master/page")
);
const InventoryMovementsPage = lazy(
  () => import("./modules/supply-chain/warehouse/inventory-movements/page")
);
const PhysicalCycleCountingPage = lazy(
  () => import("./modules/supply-chain/warehouse/physical-cycle-counting/page")
);
const RegisterOutputPage = lazy(
  () => import("./modules/supply-chain/purchasing/register-output/page")
);
const ReceiveGoodsPage = lazy(
  () => import("./modules/supply-chain/purchasing/receive-goods/page")
);
const ShippingPage = lazy(
  () => import("./modules/supply-chain/sales/shippings/page")
);

//Órdenes de Trabajo
const CreateOrderPage = lazy(
  () => import("./modules/maintenance/works-orders/create-order/page")
);
const WOCloseCostingPage = lazy(
  () => import("./modules/maintenance/works-orders/wo-close-costing/page")
);

// Recursos Humanos
const EmployeesManagementPage = lazy(
  () => import("./modules/human-resources/employees/master/page")
);

// Configuraciones
const UsersManagementPage = lazy(
  () => import("./modules/admin-settings/security/users-management/page")
);
const RolesPermissionsPage = lazy(
  () => import("./modules/admin-settings/security/roles-permissions/page")
);
const MasterTableUDCPage = lazy(
  () => import("./modules/admin-settings/settings/udc-master-tables/page")
);
const SystemSettingsPage = lazy(
  () => import("./modules/admin-settings/settings/systems-constans/page")
);
import MyAccountPage from './modules/profile/my-account/page';
import ForcePasswordResetPage from './modules/auth/ForcePasswordReset';


function Router() {
  return (
    <Switch>
      <PublicRoute path="/maintenance" component={MaintenancePage} />
      <PublicRoute path="/auth" component={SignIn} />
      <PrivateAuthLayoutRoute
        path="/"
        component={HomePage}
        title="Inicio"
      />
      <PrivateAuthLayoutRoute
        path="/my-account"
        component={MyAccountPage}
        title="Mi Cuenta"
      />
      <PrivateMenuLayoutRoute
        path="/finance/accounts-receivable/collections-management"
        component={CollectionsManagementPage}
        title="Actas de Certificaciones"
        moduleKey='collections-management'
      />
      <PrivateMenuLayoutRoute
        path="/supply-chain/warehouse/items-master"
        component={ItemMasterPage}
        title="Maestro de Artículos"
        moduleKey='items-master'
      />
      <PrivateMenuLayoutRoute
        path="/supply-chain/warehouse/invetory-movements"
        component={InventoryMovementsPage}
        title="Movimientos de Inventario"
        moduleKey='invetory-movements'
      />
      <PrivateMenuLayoutRoute
        path="/supply-chain/warehouse/counting"
        component={PhysicalCycleCountingPage}
        title="Recuentos Físicos"
        moduleKey='counting'
      />

      <PrivateMenuLayoutRoute
        path="/supply-chain/sales/sales-orders-entry"
        component={RegisterOutputPage}
        title="Registros de Salida"
        moduleKey='sales-orders-entry'
      />
      <PrivateMenuLayoutRoute
        path="/supply-chain/purchasing/receipts-processing"
        component={ReceiveGoodsPage}
        title="Recepción de Mercadería"
        moduleKey='receipts-processing'
      />
      <PrivateMenuLayoutRoute
        path="/supply-chain/sales/shipping"
        component={ShippingPage}
        title="Despacho de Mercadería"
        moduleKey='shipping'
      />
      <PrivateMenuLayoutRoute
        path="/maintenance/work-orders/create-wo"
        component={CreateOrderPage}
        title="Crear Orden de Trabajo"
        moduleKey='create-wo'
      />
      <PrivateMenuLayoutRoute
        path="/maintenance/work-orders/wo-close"
        component={WOCloseCostingPage}
        title="Cerrar Orden de Trabajo"
        moduleKey='wo-close'
      />
      <PrivateMenuLayoutRoute
        path="/admin-settings/security/users-management"
        component={UsersManagementPage}
        title="Gestión de Usuarios"
        moduleKey='users-management'
      />
      <PrivateMenuLayoutRoute
        path="/admin-settings/security/roles-permissions"
        component={RolesPermissionsPage}
        title="Gestión de Permisos"
        moduleKey='roles-permissions'
      />
      <PrivateMenuLayoutRoute
        path="/hr/employees/master"
        component={EmployeesManagementPage}
        title="Gestión de Empleados"
        moduleKey='master'
      />
      <PrivateMenuLayoutRoute
        path="/admin-settings/config/udc"
        component={MasterTableUDCPage}
        title="Maestro de Datos Tablas"
        moduleKey='udc'
      />
      <PrivateMenuLayoutRoute
        path="/admin-settings/config/systems-constants"
        component={SystemSettingsPage}
        title="Configuraciones del sistema"
        moduleKey='systems-constants'
      />

      <ProtectedAuthRoute path="/password-reset-page" component={withPageWrapper(ForcePasswordResetPage)}/>
      <Route component={NotFound} />
    </Switch>
  );
}


function App() {
  return (
    <AuthProvider>
      <Router />
      <Toaster richColors position="bottom-right" />
    </AuthProvider>
  )
}

export default App
